import NativeDateInput from 'components/common/field/NativeDateInput'
import { WizardStepProperties } from 'components/types'
import { ChangeEvent, useEffect } from 'react'

const DateSelect = ({
  name,
  label,
  value,
  required,
  isFirstInput,
  onChange,
  setIsValid,
}: WizardStepProperties) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target
    if (required && value === '') {
      setIsValid?.(false)
    } else {
      setIsValid?.(true)
    }

    onChange({ name, value, type })
  }

  useEffect(() => {
    if (!required) {
      setIsValid?.(true)
    }
  }, [required, setIsValid])

  const labelId = `${name}-label`

  return (
    <div>
      <span
        id={labelId}
        className="mb-2 block p-2 text-lg font-bold text-imovSecondaryDark sm:text-base"
      >
        {label}
      </span>
      <NativeDateInput
        id={name}
        name={name}
        aria-labelledby={labelId}
        value={value as string}
        onChange={handleChange}
        required={required}
        autoFocus={isFirstInput}
        className="date-input-native my-2 w-full cursor-text rounded-md border-2 border-imovGray p-3 text-lg focus:border-imovPrimaryLight focus:outline-none sm:p-2 sm:text-base"
      />
    </div>
  )
}

export default DateSelect
